export const getTypePresets = ({ type, icon, variant, title, message }) => {
  const typePresets = {
    confirm: {
      icon,
      variant: variant || 'primary',
      title: title || 'Confirm',
      message
    },
    'unsaved-changes': {
      icon: icon || 'info-circle-filled',
      variant: variant || 'danger',
      title: title || 'Unsaved changes',
      message: message || 'You have unsaved changes. Are you sure you want to leave without saving?'
    }
  };

  return typePresets[type] || typePresets.confirm;
};
